import type { AccessConstraint } from '@sb/shared/access';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the my-account routes. */
export const myAccountAccess = {
  timesheet: { permission: ['View all timesheets', 'View own timesheet'] },
  absence: {
    permission: ['View absentee', 'View own absentee', 'View vacation hours'],
    subscriptionPlan: PlanType.BASIC,
  },
  'plus-minus': {
    permission: ['View plus min hours', 'View own plus min hours'],
    subscriptionPlan: PlanType.BASIC,
  },
  minijob: {
    permission: ['View minijob', 'View own minijob'],
    subscriptionPlan: PlanType.BASIC,
  },
  files: { subscriptionPlan: PlanType.BASIC },
} satisfies Record<string, AccessConstraint>;
